import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatformHero = styled.section`
	color: ${CSSVars.white};
	text-align: center;
	overflow: hidden;
	padding: 50px 20px;
	background: ${CSSVars.gray700};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	&.full-width {
		.hero-wrapper {
			h1 {
				max-width: 920px;
			}
		}
	}

	.hero-wrapper {
		> :last-child {
			margin-bottom: 0;
		}

		h1 {
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize3XL};
			font-weight: 600;
			max-width: 750px;
			text-align: left;
			margin: 0px auto 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 0px auto 20px;
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize5XL};
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSize2XL};
			font-weight: 600;
			max-width: 1200px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize4XL};
			}
		}

		p {
			max-width: 930px;
			font-weight: 300;
			color: ${CSSVars.white};
			font-size: ${CSSVars.fontSizeLG};
			margin: 20px auto;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				margin: 30px auto;
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
